import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Footer = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      toast.success("You're on the list. Welcome to Texas Journal.");
      setEmail("");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Subscription failed. Try again.";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer data-testid="footer" className="bg-black text-white">
      <div className="px-4 md:px-8 lg:px-12 pt-24 md:pt-32 pb-12 border-t border-white/10">
        <div className="grid lg:grid-cols-2 gap-16">
          <div>
            <h2 className="font-serif-display uppercase tracking-tighter leading-[0.85] text-[16vw] lg:text-[8vw] font-light">
              Be
              <br />
              <span className="italic font-extralight">Seen.</span>
            </h2>
          </div>

          <div className="flex flex-col justify-between gap-12">
            <form onSubmit={subscribe} data-testid="newsletter-form">
              <label className="font-accent uppercase text-xs tracking-[0.3em] text-white/50">
                Join the list
              </label>
              <div className="flex items-center gap-4 mt-3 border-b border-white/30 pb-3">
                <input
                  data-testid="newsletter-email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  className="flex-1 bg-transparent outline-none font-light text-lg placeholder-white/40"
                />
                <button
                  type="submit"
                  disabled={loading}
                  data-testid="newsletter-submit"
                  className="font-accent uppercase text-xs tracking-[0.2em] hover:text-white/60 transition-colors disabled:opacity-50"
                >
                  {loading ? "…" : "Subscribe"}
                </button>
              </div>
            </form>

            <div className="grid grid-cols-2 sm:grid-cols-3 gap-8 font-accent uppercase text-xs tracking-[0.15em] text-white/60">
              <div className="space-y-3">
                <p className="text-white/40">Explore</p>
                <a href="#editorial" className="block link-underline w-fit">Editorial</a>
                <a href="#directory" className="block link-underline w-fit">Directory</a>
                <a href="#issues" className="block link-underline w-fit">Issues</a>
              </div>
              <div className="space-y-3">
                <p className="text-white/40">Business</p>
                <a href="#advertise" className="block link-underline w-fit">Advertise</a>
                <a href="#directory" className="block link-underline w-fit">Get Listed</a>
              </div>
              <div className="space-y-3">
                <p className="text-white/40">Follow</p>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="block link-underline w-fit">Instagram</a>
                <a href="https://pinterest.com" target="_blank" rel="noopener noreferrer" className="block link-underline w-fit">Pinterest</a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <img src="/logo-tj.png" alt="Texas Journal" className="h-6 w-auto object-contain" />
          <p className="font-light text-xs text-white/40">
            © {new Date().getFullYear()} Texas Journal — A Texas Fashion Magazine. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
